import { animate, stagger } from 'motion';

export default class LoginAnimation {
	static init() {
		const loginBlock = document.querySelector('.block-login');
		if (!loginBlock) return;

		const header = loginBlock.querySelector('.block-login__header');
		// Set initial state - hidden
		const elements = [header].filter(Boolean);
		elements.forEach(el => {
			el.style.opacity = '0';
			el.style.transform = 'translateY(20px)';
		});

		// Fade in + slide up with stagger
		animate(
			elements,
			{ opacity: [0, 1], transform: ['translateY(20px)', 'translateY(0px)'] },
			{ duration: 0.6, delay: stagger(0.2, { start: 0.3 }), easing: 'ease-out' }
		);
	}
}
